import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { getQtdVisitasGeral } from '../../../../../services/DashboardService';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';


const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 20,
    minHeight: 120,
    maxHeight: 120
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.warning.main,
    height: 56,
    width: 56,
    zIndex: 1,
    marginRight: -50
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },

  iconDiferencaPositivo: {
    color: theme.palette.success.dark
  },
  iconDiferencaNegativo: {
    color: theme.palette.error.dark,
  },
  valorDiferencaPositivo: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  valorDiferencaNegativo: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  cardContent: {
    zIndex: 1,
    marginTop: -90,
    marginRight: 25,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  gridProgress: {
    display: 'flex',
    justifyContent: 'center'
  }

}));

const VisitasGeral = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [qtdVisitasMes, setQtdVisitasMes] = useState();
  const [mostrarProgress, setMostrarProgress] = useState(false);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);

  useEffect(() => {
    try {
      getDados();

    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getQtdVisitasGeral();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setQtdVisitasMes(dados.result);
      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  return (
    <Grid
      container
      style={{
        display:'flex',
        justifyContent: 'center',
        verticalAlign: 'middle'
      }}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          {...rest}
          className={clsx(classes.root, className)}
          elevation={3}
        >
          <CardContent

          >
            {
              mostrarProgress &&
              <Grid
                container
                md={12}
                xs={12}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                  className={clsx({
                    [classes.gridProgress]: true
                  })}
                >
                  <CircularProgress/>
                </Grid>
              </Grid>
            }
            {
              !mostrarProgress && !mostrarAlertaErro && qtdVisitasMes &&
              <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                    >
                      VISITAS HOJE
                    </Typography>

                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography variant="h3">{qtdVisitasMes.quantidadeHoje}</Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <div className={classes.difference}>


                      <InsertEmoticonIcon
                        fontSize={'small'}
                        className={clsx({
                          [classes.iconDiferencaPositivo]: true,
                        })}
                      />
                      <Typography
                        className={clsx({
                          [classes.valorDiferencaPositivo]: true
                        })}
                        variant="body2"
                      >
                        {`${qtdVisitasMes.quantidadeGeral} visita(s) registradas`}
                      </Typography>
                    </div>
                  </Grid>

              </Grid>
            }
            {
              mostrarAlertaErro &&
              <Grid
                container
                md={12}
                xs={12}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                  className={clsx({
                    [classes.gridProgress]: true
                  })}
                >
                  <Alert severity={'warning'} variant={'outlined'} >Falha ao carregar dados</Alert>
                </Grid>
              </Grid>
            }


          </CardContent>
        </Card>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className={clsx({
          [classes.cardContent]: true
        })}
      >
        <Avatar className={classes.avatar}>
          <EventAvailableIcon className={classes.icon} />
        </Avatar>
      </Grid>
    </Grid>
  );
};

VisitasGeral.propTypes = {
  className: PropTypes.string
};

export default VisitasGeral;
